<script>
    import { onMount } from "svelte";
    import { SPRITES, TYPE_SPRITE_MAP } from "../../constants/sprites";
    import ComponentTiled from "./ComponentTiled.svelte";
    import {
      SetupStore,
      MerchantClicked,
      IsTurn,
      PlayerId,
      GameStateStore
    } from "../stores/gameStore";

    export let scale, left, top;

    $: boardId = $SetupStore?.playerboards?.[$PlayerId]?.board_ID;
    $: isClickable = ($IsTurn === true) && (boardId === "MERCHANT_SPEC") && ($GameStateStore?.name != "merchantTakeItem") && ($GameStateStore?.name != "actionSelection");

    const textTokenName = _('Merchant Token');
    const textTokenDescription = _('Each turn, you can place this token on an item or the potions pile. If someone takes or crafts the item (or potion) marked with this token, the merchant may take 1 class one item or a potion.');
    
    function setStatusBar () {
        const textMerchantLine = _('${you} must choose where to place your merchant token');
        window.GAME.statusBar.setTitle(textMerchantLine, '');
    }
    
    const _id = Math.round(Math.random() * 10000).toString();

    onMount(() => {
      window.GAME.addTooltipHtml(
        _id,
        `<div style="display:flex; flex-direction:column; max-width: 350px; word-wrap: break-word;">
          <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
            <div class="headline">
              ${textTokenName}</div>
            </div>
              <hr style="width:100%;"/>
              ${textTokenDescription}
            </div>
          </div>`
      );
    });
</script>  

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="token"
  style:position="absolute"
  style:left="{left}px"
  style:top="{top}px"
  id={_id}
  class:not-clickable={!isClickable}
  on:click={(e) => {
    if (!isClickable) return;
    e.preventDefault();
    e.stopPropagation();
    MerchantClicked.set(true);
    setStatusBar();
  }}
>
  <ComponentTiled
    width={133 * scale}
    sprite={SPRITES["TOKENS"]}
    borderRadius={1}
    offset={$SetupStore.data.gameTokens["MERCHANT"].offset}
    className="shadow-sm"
  />
</div>
  

<style>
  .token {
    position: absolute;
    cursor: pointer;
    transition: filter 0.2s ease;
    outline: rgb(255, 255, 255) solid 2px;
    outline-offset: 2px;
    border-radius: 50%;
    filter: drop-shadow(0px 0px 3px #ee7f84);
  }

  .token:hover {
    filter: brightness(1.2);
  }

  /* Disable hover effect when it's not clickable */
  .not-clickable {
    pointer-events: none;
    outline: none;
    filter: drop-shadow(0px 0px 3px #0000006b);
  }

  .not-clickable:hover {
    filter: none; /* No brightness effect on hover */
  }
</style>